module.exports = {
    headers:{
        'x-access-token': localStorage.getItem('token')
    }
}